<template>
  <div class="Search">
    <transition name="fade" mode="out-in">
      <alert v-if="error" :content="alertContent" @confirm="closeAlert" />
    </transition>
    <transition name="fade" mode="out-in">
      <div v-if="removedPost" class="Search__info">
        <div class="Search__info-content">Removed Post</div>
      </div>
    </transition>
    <div class="panel">
      <div class="Grid-row">
        <div class="header-title">Paste post url</div>
      </div>
      <div class="Grid-row">
        <div class="Grid-column-4">
          <input
            v-model="userInput"
            :class="{ 'has-error': !userInput && error }"
            class="input"
            type="text"
            placeholder="Url"
          />
        </div>
      </div>
      <div class="Grid-row">
        <button class="button button-success" @click="searchUser">
          Remove post
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from '@/components/common/navigation/Alert';

export default {
  name: 'Search',
  components: {
    Alert,
  },
  data() {
    return {
      alertContent: 'Wrong url',
      userInput: '',
      error: false,
      removedPost: false,
      timer: null,
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    },
  },

  methods: {
    searchUser() {
      if (!this.userInput) {
        this.error = true;
      } else {
        if (this.validateStagingUrl(this.userInput)) {
          this.$store
            .dispatch(
              'removePost',
              this.userInput.replace(
                'https://web.staging.kingsch.at/posts/',
                ''
              )
            )
            .then((resp) => {
              if (resp.ok && resp.status === 200) {
                this.removedPostInfo();
              }
            })
            .catch(() => {
              this.error = true;
            });
        } else if (this.validateProductionUrl(this.userInput)) {
          this.$store
            .dispatch(
              'removePost',
              this.userInput.replace('https://web.kingsch.at/posts/', '')
            )
            .then((resp) => {
              if (resp.ok && resp.status === 200) {
                this.removedPostInfo();
              }
            })
            .catch(() => {
              this.error = true;
            });
        } else if (this.validateStagingFriendlyUrl(this.userInput)) {
          this.$store
            .dispatch(
              'removePost',
              this.userInput.replace('http://kingschat.appunite.com/p/', '')
            )
            .then((resp) => {
              if (resp && resp.ok && resp.status === 200) {
                this.removedPostInfo();
              }
            })
            .catch(() => {
              this.error = true;
            });
        } else if (this.validateProductionFriendlyUrl(this.userInput)) {
          this.$store
            .dispatch(
              'removePost',
              this.userInput.replace('https://www.kingsch.at/p/', '')
            )
            .then((resp) => {
              if (resp.ok && resp.status === 200) {
                this.removedPostInfo();
              }
            })
            .catch(() => {
              this.error = true;
            });
        }
      }
    },
    removedPostInfo() {
      this.error = false;
      this.userInput = '';
      this.removedPost = true;
      if (typeof this.timer === 'number') {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        this.removedPost = false;
      }, 1000);
    },
    closeAlert() {
      this.error = false;
      this.alertContent = 'Wrong url';
    },
    validateStagingUrl(url) {
      if (!url.includes('https://web.staging.kingsch.at/posts/')) {
        this.error = true;
      }
      return url.includes('https://web.staging.kingsch.at/posts/');
    },
    validateProductionUrl(url) {
      if (!url.includes('https://web.kingsch.at/posts/')) {
        this.error = true;
      }
      return url.includes('https://web.kingsch.at/posts/');
    },
    validateStagingFriendlyUrl(url) {
      if (!url.includes('http://kingschat.appunite.com/p/')) {
        this.error = true;
      }
      return url.includes('http://kingschat.appunite.com/p/');
    },
    validateProductionFriendlyUrl(url) {
      if (!url.includes('https://www.kingsch.at/p/')) {
        this.error = true;
      }
      return url.includes('https://www.kingsch.at/p/');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/components/search/Search.scss';
</style>
